/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { checkmarkBold } from "../assets/checkmark-bold";
import { Icon, type IconBaseProps } from "../icon";

export const IconCheckmarkBold = (props: IconBaseProps) => <Icon {...props} svg={checkmarkBold} />;

IconCheckmarkBold.displayName = "IconCheckmarkBold";
